module.exports = __webpack_public_path__ + "img/icon5.a3271700.png";